import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule, Routes } from '@angular/router';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss']
})
export class PasswordresetComponent implements OnInit {
  resetError:boolean = false;
  reset: any = FormGroup;
  model: any = {
    identifier:null
  };
  forgotEmail:string=null;
  forgotSuccess:boolean = false;
  constructor(private fb: FormBuilder, private authService:AuthService, private router:Router) { }

  ngOnInit() {
    this.reset = this.fb.group({
      identifier: ['', Validators.compose([Validators.required])]
    });
  }

  resetPassword () {
    this.authService.resetPassword(this.model.identifier).subscribe(res=> {
      this.forgotEmail = this.model.identifier;
      this.forgotSuccess = true;
    },
    error => {
      this.resetError = true;
    });
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/passwordreset/passwordreset.component.ts